import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import api from '@common/utils/api';
import GiftCardPurchaseModal from './GiftCardPurchaseModal';
const LoginModal = React.lazy(() => import('@components/login/LoginModal'));
const ProductActionAddToBag = (props) => {
    var _a, _b, _c, _d;
    let { t } = useTranslation();
    const [showAddToBagMessage, setShowAddToBagMessage] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [giftCardPurchase, setGiftCardPurchase] = useState(false);
    useEffect(() => {
        let quickShopTimeout;
        if (showAddToBagMessage) {
            quickShopTimeout = setTimeout(() => {
                setShowAddToBagMessage(false);
            }, 5000);
        }
        return () => {
            clearTimeout(quickShopTimeout);
        };
    }, [showAddToBagMessage]);
    const addToBag = (card = null) => {
        setShowAddToBagMessage(true);
        props.onAddStart && props.onAddStart();
        if (!props.size) {
            console.log('no size, triggering size selector:', props.triggerOpenSize);
            props.triggerOpenSize && props.triggerOpenSize();
            // let selectSize = props.stickyPDP ? (document.querySelector('.sticky-modal') as HTMLDivElement) : (document.querySelector('.selector-size-expanded') as HTMLDivElement);
            setTimeout(() => {
                // selectSize?.focus();
            }, 100);
            return;
        }
        const productId = `${props.product.id}${props.size.id}`;
        api.addToBag(productId, 1, null, card).then((data) => {
            if (data.error) {
                props.updateErrorMessage && props.updateErrorMessage(data.message);
                props.updateErrorTitle && props.updateErrorTitle(data.label);
            }
            else {
                if (data.quantityTotal) {
                    const header = document.querySelector('header');
                    const firstRefine = document.querySelector('.listing-container .refine');
                    header === null || header === void 0 ? void 0 : header.style.removeProperty('transform');
                    if (firstRefine) {
                        firstRefine.style.removeProperty('transform');
                    }
                    // console.info('update minicart');
                    customEventBus.emit('bag:update', { fromMinicart: true });
                    let wrapper = document.querySelector('.minibag');
                    wrapper === null || wrapper === void 0 ? void 0 : wrapper.focus();
                    if (props.isSearchTile) {
                        document.querySelector('#infinite-scroll-wrapper').classList.remove('stick-top');
                        document.querySelector('#infinite-scroll-wrapper').classList.add('minicart-overlay');
                    }
                    if (props.isLookCarousel) {
                        customEventBus.emit('minicart:update', { pid: productId });
                    }
                    else {
                        customEventBus.emit('minicart:update', { fromAddToBag: true, pid: productId });
                    }
                }
                if (props.product.isGiftCard) {
                    analytics.addToBag(props.product, null, null, card.gcAmount);
                    analytics.addGiftcardToBag({ gcAmount: card.gcAmount, gcMessage: card.gcMessage });
                }
                else {
                    if (props.pushAnalytics) {
                        props.pushAnalytics();
                    }
                }
                // sposto qui la callback, in modo che viene eseguita come ultima operazione se la chiamata va a buon fine
                if (props.callback) {
                    props.callback();
                }
            }
        });
    };
    const btnModifiers = useMemo(() => {
        if (props.noModifiers) {
            return [];
        }
        let btnClass = props.secondary ? 'button--secondary' : 'button--primary';
        if (props.inverted) {
            btnClass += '-inverted';
        }
        return [btnClass];
    }, [props.secondary, props.inverted, props.noModifiers]);
    if (!props.product) {
        return null;
    }
    return !window.loggedin && window.loginUrl && ((_a = props.product) === null || _a === void 0 ? void 0 : _a.unlock) ? (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: btnModifiers, className: props.className, onClick: () => {
                var _a, _b;
                props.inPDP && analytics.loginToPurchase((_a = props.product) === null || _a === void 0 ? void 0 : _a.id, 'pdp', 'pdp');
                props.inShopTheLook && analytics.loginToPurchase((_b = props.product) === null || _b === void 0 ? void 0 : _b.id, 'flp', 'shop by look');
                setLoginOpen(true);
            } }, t('button.signintopurchase')),
        React.createElement(LoginModal, { reloadPage: true, incontext: "membersonly", modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status) }))) : showAddToBagMessage && props.isLookCarousel ? (React.createElement(Button, { type: "button", cls: btnModifiers, className: "button--added-item", onClick: () => addToBag() }, t('bag.justadded'))) : (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: btnModifiers, ariaHaspopup: "dialog", onClick: () => {
                if (props.product.isGiftCard) {
                    analytics.addToCartGiftCard(props.product.id);
                    setGiftCardPurchase(true);
                }
                else {
                    addToBag();
                }
            } }, props.product.isGiftCard
            ? props.product.type == 'tile' || props.product.type == 'size'
                ? t('gc.chooseam')
                : t('gc.shopnow')
            : ((_d = (_c = (_b = props.product.variationAttributes) === null || _b === void 0 ? void 0 : _b.find((va) => va.id == 'color')) === null || _c === void 0 ? void 0 : _c.values.find((va) => va.selected)) === null || _d === void 0 ? void 0 : _d.preorderable)
                ? t('button.preordernow')
                : t('button.addtobag')),
        React.createElement(GiftCardPurchaseModal, { isOpen: giftCardPurchase, onRequestClose: () => setGiftCardPurchase(false), type: "create", product: props.product, onSubmit: (card) => addToBag(card) })));
};
export default ProductActionAddToBag;
